// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page-stat-details{cursor:pointer;pointer-events:auto;transition:.1s ease-in-out}.page-stat-details:hover{transform:scale(1.02)}`, "",{"version":3,"sources":["webpack://./resources/app/modules/common/PageStats/index.scss"],"names":[],"mappings":"AAAA,mBACI,cAAA,CACA,mBAAA,CACA,0BAAA,CAGJ,yBACI,qBAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
